// Import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min.js';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templatePricing from './routes/pricing';
import templatePricingV2 from './routes/pricing';
import templateHome from './routes/price';
import templatePricing2024 from './routes/pricing2024';
import templatePricing2025 from './routes/pricing2025';
import templatePricingRestructured from './routes/pricing2024';
import templateChannelIntegration from './routes/channelIntegration';
import singlePost from './routes/singlePost';
import category from './routes/category';
import archive from './routes/categoryTestimonials';
import hotelPaymentProcessing from './routes/countryPicker';
import appStore from './routes/appStore';
import templateContact from './routes/contact';
import mobileApp from './routes/mobileApp';
import carouselCustomerStories from './routes/carouselCustomerStories';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  templatePricing,
  templatePricingV2,
  templatePricing2024,
  templatePricingRestructured,
  templateHome,
  templatePricing2025,
  category,
  singlePost,
  archive,
  hotelPaymentProcessing,
  templateChannelIntegration,
  appStore,
  templateContact,
  mobileApp,
});

/** Load Events */
jQuery(document).ready(() => {
  routes.loadEvents();

  // Initialize Swiper block if present
  if (document.querySelector('.mySwiper')) {
    carouselCustomerStories.init();
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js